import React, { useEffect, useState } from 'react'
import useAxios from 'hooks/useAxios'
import ArchivedCustomDashboardModal from '.'
import { useNavbarMenuContext } from 'organisms/NavBar/context'
import { toast } from 'libs/toast'

export const ArchivedCustomDashboardContainer = ({ Modal, onClose }) => {
  const [archivedCustomDashboard, setArchivedCustomDashboard] = useState(null)
  const { createContextData } = useNavbarMenuContext()

  const { data: archivedCustomDashboardData, loading } = useAxios({
    url: 'dashboard/dashboards/?status=archived',
    method: 'get',
  })
  const { fetch: updateDashboardStatus } = useAxios({
    method: 'patch',
    skip: true,
  })
  const { fetch: deleteDashboard } = useAxios({
    method: 'delete',
    skip: true,
  })

  useEffect(() => {
    if (archivedCustomDashboardData) {
      setArchivedCustomDashboard(archivedCustomDashboardData)
    }
  }, [archivedCustomDashboardData])

  const handleUpdateSuccess = (token, res) => {
    setArchivedCustomDashboard((prev) => ({
      ...prev,
      results: prev.results.filter((item) => item.token !== token),
    }))
    createContextData('dashboard', res.data)
    toast.success('The dashboard was successfully restored.')
  }

  const onClickRestore = (token) => {
    updateDashboardStatus({ url: `dashboard/dashboards/${token}/`, data: { status: 'active' } })
      .then((res) => handleUpdateSuccess(token, res))
      .catch((err) => {
        console.error(err)
        toast.error(
          'Uh oh. There was a problem restoring the dashboard. Please try again or contact Simplesat support.'
        )
      })
  }

  const onClickDelete = (token) => {
    deleteDashboard({
      url: `dashboard/dashboards/${token}/`,
    })
      .then(() => {
        setArchivedCustomDashboard((prev) => {
          const filteredResults = prev.results.filter((item) => item.token !== token)

          return { ...prev, results: filteredResults }
        })
        toast.success('The dashboard was successfully deleted.')
      })
      .catch((err) => {
        console.error(err)
        toast.error(
          'Uh oh. There was a problem deleting the dashboard. Please try again or contact Simplesat support.'
        )
      })
  }

  return (
    <React.Fragment>
      <ArchivedCustomDashboardModal
        Modal={Modal}
        onRestore={onClickRestore}
        onDelete={onClickDelete}
        archivedItems={archivedCustomDashboard}
        isLoading={loading}
        onClose={onClose}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ArchivedCustomDashboardModel/container.js